import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { koblePaaAuthLenke } from "./lib/authLenke";

// Supabase legger tokenene sine i fragmentet — samme sted hash-ruteren leser
// stien fra. Må skje FØR appen monteres, ellers har ruteren allerede sett
// «access_token=…», ikke funnet noen rute, og sendt brukeren til innloggingen.
koblePaaAuthLenke();

// After a new deploy, the service worker may replace its pre-cache while
// the page still holds old chunk references. A reload picks up the new
// HTML + new SW cache. A sessionStorage guard prevents infinite loops.
// See https://vite.dev/guide/build.html#load-error-handling
window.addEventListener("vite:preloadError", () => {
  const key = "chunk-reload";
  if (!sessionStorage.getItem(key)) {
    sessionStorage.setItem(key, "1");
    window.location.reload();
  }
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
